import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetLicenseService } from "./asset-license.service";
import { AssetLicenseDto } from "./dto/asset-license.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { AssetsRequest } from "./dto/asset-license-active-inactive";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";

@Controller('asset_license')
@ApiTags('asset_license')
export class AssetLicenseController{
    constructor(
        private assetLicenseService : AssetLicenseService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createAssetLicense')
    async createAssetLicense(@Body() createDto:AssetLicenseDto): Promise<CommonResponse> {
        try {
            return await this.assetLicenseService.createAssetLicense(createDto,false);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAllAssetsLicense')
    async getAllAssetsLicense(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetLicenseService.getAllAssetsLicense(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    
    @Post('/getAllHistoryLicense')
    async getAllHistoryLicense(): Promise<CommonResponse> {
        try {
            return await this.assetLicenseService.getAllHistoryLicense();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/updateLicense')
    async updateLicense(@Body() createDto:AssetLicenseDto): Promise<CommonResponse> {
        try {
            return await this.assetLicenseService.createAssetLicense(createDto,true);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/activateorDeactivateLicense')
    async activateorDeactivateLicense(@Body() AssetsCatagoryAct: AssetsRequest): Promise<CommonResponse> {
        try {
            return await this.assetLicenseService.activateorDeactivateLicense(AssetsCatagoryAct);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
}